import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class Quote {
    constructor(quote) {
        this.quote = quote
        this.cover = quote.querySelector('.quote__cover')

        gsap.timeline({
            scrollTrigger: {
                trigger: this.quote,
                start: "top",
                end: "bottom 15%",
                scrub: 1,
            }
        }).to(this.cover, {
            scale: 1.15,
            translateY: '-7.5%',
            ease: "ease-in-out",
        })

    }

}

export default Quote